import type { DeliveryType } from '@libs/core';

import { StockErrorItem } from '../types';

export const itemHasStockError = (payload: {
    itemId: string;
    fulfillmentMethod: DeliveryType;
    stockError?: StockErrorItem;
}): StockErrorItem | undefined => {
    const { itemId, fulfillmentMethod, stockError } = payload;

    if (!stockError) {
        return undefined;
    }

    if (
        stockError.lineItemId === itemId &&
        stockError.fulfillmentMethod.toLowerCase() === fulfillmentMethod.toLowerCase()
    ) {
        return stockError;
    }
};
